export function getRulesAndRegulationsFileUrl(locale: string) {
  return {
    en: `/RR_VEN_Lasso_2026.pdf`,
    fr: `/RR_VFR_Lasso_2026.pdf`,
  }[locale];
}
